import { Layout } from 'antd';
import { AppBox } from './boxes/AppBox';

export function AppSider(props) {
  return <AppBox {...props} as={Layout.Sider} />;
}
